var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 392,
    viewBox: "0 0 744 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691.872 8.86401L372 320.672L52.128 8.86401C46.4129 3.28178 38.7409 0.156616 30.752 0.156616C22.763 0.156616 15.0911 3.28178 9.37599 8.86401C6.60877 11.5753 4.41038 14.8115 2.90958 18.3831C1.40878 21.9547 0.635742 25.7899 0.635742 29.664C0.635742 33.5381 1.40878 37.3733 2.90958 40.9449C4.41038 44.5165 6.60877 47.7527 9.37599 50.464L349.664 382.24C355.64 388.065 363.655 391.325 372 391.325C380.345 391.325 388.36 388.065 394.336 382.24L734.624 50.528C737.411 47.8147 739.626 44.5705 741.138 40.9871C742.651 37.4036 743.43 33.5535 743.43 29.664C743.43 25.7745 742.651 21.9243 741.138 18.3409C739.626 14.7575 737.411 11.5133 734.624 8.79999C728.909 3.21776 721.237 0.0926208 713.248 0.0926208C705.259 0.0926208 697.587 3.21776 691.872 8.79999V8.86401Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.188a889b98f104fe5bed95e3619ad206.svg";
export { ForwardRef as ReactComponent };